export default __webpack_public_path__ + "static/media/logo.0d374729.svg";